import { useMutation, useQuery } from '@tanstack/react-query';
import { apiFetch, useError } from './api';
import { normalizeQuizApiData } from '../pages/facilitator/body/normalizeQuizApiData';

export const ADMIN_QUIZ_MODULES = Object.freeze({
  introduction: '1',
  strategiesPart1: '2',
  strategiesPart2: '3',
  hybridDelivery: '4',
});

export const getAdminQuiz = async (moduleKey) => {
  const response = await apiFetch(
    `${process.env.REACT_APP_API_URL}/api/quiz/${moduleKey}`,
    {
      method: 'GET',
      cache: 'no-store',
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return response.json();
};

export const putAdminQuiz = async (payload) => {
  const response = await apiFetch(`${process.env.REACT_APP_API_URL}/api/quiz`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });

  try {
    return await response.json();
  } catch (_error) {
    return payload;
  }
};

export const useAdminQuizQuery = (moduleKey, options = {}) => {
  const { checkError } = useError();
  const hasToken = Boolean(localStorage.getItem('token'));
  const { onError, ...queryOptions } = options;

  return useQuery({
    queryKey: ['adminQuiz', moduleKey],
    queryFn: () => getAdminQuiz(moduleKey),
    select: normalizeQuizApiData,
    enabled: Boolean(moduleKey) && hasToken,
    retry: false,
    ...queryOptions,
    onError: (error) => {
      checkError(error);
      onError?.(error);
    },
  });
};

export const useAdminQuizMutation = (options = {}) => {
  const { checkError } = useError();
  const { onError, ...mutationOptions } = options;

  return useMutation({
    mutationFn: putAdminQuiz,
    ...mutationOptions,
    onError: (error, variables, context) => {
      checkError(error);
      onError?.(error, variables, context);
    },
  });
};
